module.exports = __webpack_public_path__ + "img/simple-footer.bed712ee.svg";